import { PrintPrice } from '@core/api';
import { apiActionFactory } from '@core/store';

export const [fetchPrintPriceSuccess, fetchPrintPriceFail] = apiActionFactory<{ printPrice: PrintPrice }>('[Prints/API] Fetch Print Price');
